import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import baseMessage from '../components/baseMessage.vue'
import { visitorProgramDetail } from '@/api/gucangSales/followUpManage'
import type { FbuFollowUpRecordEdit } from '@/typings/api/followUpManage'

const __default__ = {
  name: 'DcCosFbuFollowUpRecordVisitingPlan'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const form = ref<FbuFollowUpRecordEdit>({
  saleChance: {},
  visitPlanList: {}
})
const permissionBasic = {
  save: 'fbu_visitor_complete_btn'
}
// 获取访客计划详情
const getvisitorProgramDetail = () => {
  visitorProgramDetail(route.query.planId as string).then((res) => {
    const {
      id,
      mode,
      customerName,
      endTime,
      startTime,
      chanceName,
      contactId,
      visitRefId,
      chanceId,
      purpose,
      fbuAssistPersons
    } = res.data
    form.value = {
      ...form.value,
      planId: id,
      mode,
      customerName,
      endTime,
      startTime,
      contactId,
      chanceId,
      chanceName,
      fbuPurpose: purpose,
      fbuAssistPersons,
      followRefId: visitRefId
    }
  })
}
onMounted(() => {
  if (route.query.planId) {
    getvisitorProgramDetail()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(baseMessage, {
            disabled: false,
            data: form.value,
            returnPath: "/fbu/visitorProgram",
            permissionPage: permissionBasic
          }, null, 8, ["data"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})